import Login from "@/pages/Login/Login.vue";
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import PowerBIGenerico from "@/pages/PowerBI/PowerBIGenerico.vue";

let routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    title: "Login",
    icon: "",
    menu: false,
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    title: "Dashboard",
    menu: true,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/workspaceId/:workspaceId/reportId/:reportId",
    name: "Relatorio",
    component: PowerBIGenerico,
    title: "Relatório",
    menu: true,
    meta: {
      requireAuth: true,
    },
  }
];

export default routes;
